var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdvertising(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -29 512.00001 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#faf8f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4041,
    stopColor: "#eceef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6353,
    stopColor: "#d5dcea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#b5c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a1b5d8"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 198.4694562602,
    x2: 198.4694562602,
    xlinkHref: "#a",
    y1: 151.2006061938,
    y2: 387.8526294488
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2277,
    stopColor: "#fd4571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4662,
    stopColor: "#f93867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7098,
    stopColor: "#f12358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9554,
    stopColor: "#e60642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 85.966342821,
    x2: 180.5195316846,
    xlinkHref: "#c",
    y1: 362.75919749,
    y2: 391.3220834886
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4003d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2234,
    stopColor: "#cd1845",
    stopOpacity: 0.223529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5034,
    stopColor: "#b82e4d",
    stopOpacity: 0.501961
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7682,
    stopColor: "#ab3c51",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 142.3959953034,
    x2: 107.349881421,
    xlinkHref: "#e",
    y1: 395.124638848,
    y2: 333.607310454
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2378,
    stopColor: "#ffcb0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8632,
    stopColor: "#ffa215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9517"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 111.2733089892,
    x2: 148.734558027,
    xlinkHref: "#g",
    y1: 359.5157262924,
    y2: 370.8321358608
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 136.6075818358,
    x2: 111.6277938474,
    xlinkHref: "#e",
    y1: 434.974820677,
    y2: 378.6771839376
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 111.2733089892,
    x2: 148.734558027,
    xlinkHref: "#g",
    y1: 405.6199406126,
    y2: 416.936350181
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 117.2839907876,
    x2: 93.4399397578,
    xlinkHref: "#e",
    y1: 368.5816439134,
    y2: 242.0863675992
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 33.1363530618,
    x2: 57.558863948,
    xlinkHref: "#g",
    y1: 196.4633330936,
    y2: 262.4042429962
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 109.1977002542,
    x2: 109.1977002542,
    xlinkHref: "#c",
    y1: 178.3600092364,
    y2: 317.8091922932
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 333.143484324,
    x2: 677.9598709186,
    xlinkHref: "#g",
    y1: 154.3509134298,
    y2: 449.2278024876
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 445.1401191142,
    x2: 255.1825159232,
    xlinkHref: "#a",
    y1: 217.951982327,
    y2: 217.951982327
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 414.9934457684,
    x2: 164.2522807732,
    y1: 305.2854661276,
    y2: 125.112287533
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6699,
    stopColor: "#8190a4",
    stopOpacity: 0.670588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 180.9099569504,
    x2: 144.1077827056,
    xlinkHref: "#a",
    y1: 209.51050419,
    y2: 209.51050419
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 217.5385530814,
    x2: 180.7363788366,
    xlinkHref: "#a",
    y1: 209.51050419,
    y2: 209.51050419
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 147.4236366794,
    x2: 121.4237635468,
    xlinkHref: "#e",
    y1: 236.4360937988,
    y2: 200.8228643786
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 125.180038102,
    x2: 125.180038102,
    xlinkHref: "#g",
    y1: 204.1757630742,
    y2: 239.0365529554
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 356.544906144,
    x2: 380.6436521852,
    xlinkHref: "#c",
    y1: 193.449258073,
    y2: 258.5158523058
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m123.101562 108.308594c-48.269531 0-87.402343 39.128906-87.402343 87.398437v43.230469c0 48.269531 39.132812 87.402344 87.402343 87.402344 76.546876 0 151.25 23.488281 214.023438 67.296875l24.113281 16.828125v-386.285156l-24.113281 16.832031c-62.773438 43.804687-137.476562 67.296875-214.023438 67.296875zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m137.625 297.253906h-78.019531l12.257812 28.886719c8.132813 19.167969 12.324219 39.777344 12.324219 60.597656v27.617188c0 21.542969 17.464844 39.007812 39.007812 39.007812 21.546876 0 39.011719-17.464843 39.011719-39.007812v-27.617188c0-20.820312-4.191406-41.429687-12.324219-60.597656zm0 0",
    fill: "url(#d)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m132.535156 347.679688h-25.304687c-7.929688 0-14.355469 6.429687-14.355469 14.359374v.15625c0 4.316407 1.910156 8.175782 4.921875 10.808594l59.785156 59.78125c2.949219-5.488281 4.625-11.761718 4.625-18.429687v-27.617188c0-5.394531-.289062-10.773437-.847656-16.117187l-18.015625-18.015625c-2.632812-3.015625-6.492188-4.925781-10.808594-4.925781zm0 0",
    fill: "url(#f)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m132.535156 376.554688h-25.304687c-7.929688 0-14.355469-6.429688-14.355469-14.359376v-.15625c0-7.929687 6.425781-14.359374 14.355469-14.359374h25.304687c7.929688 0 14.359375 6.429687 14.359375 14.359374v.15625c0 7.929688-6.429687 14.359376-14.359375 14.359376zm0 0",
    fill: "url(#h)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m143.34375 398.707031c-2.632812-3.011719-6.492188-4.921875-10.808594-4.921875h-25.304687c-7.929688 0-14.359375 6.425782-14.359375 14.355469v.160156c0 4.3125 1.914062 8.171875 4.925781 10.804688l33.429687 33.429687c16.710938-3.5 29.484376-17.691406 30.847657-35.09375zm0 0",
    fill: "url(#i)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m132.535156 422.65625h-25.304687c-7.929688 0-14.355469-6.425781-14.355469-14.355469v-.160156c0-7.929687 6.425781-14.355469 14.355469-14.355469h25.304687c7.929688 0 14.359375 6.425782 14.359375 14.355469v.160156c0 7.929688-6.429687 14.355469-14.359375 14.355469zm0 0",
    fill: "url(#j)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m162.207031 402.359375v-15.621094c0-20.820312-4.191406-41.429687-12.324219-60.59375l-12.257812-28.890625h-78.019531l1.847656 4.355469zm0 0",
    fill: "url(#k)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m81.726562 217.324219c0 22.566406-18.296874 40.863281-40.863281 40.863281-22.570312 0-40.863281-18.296875-40.863281-40.863281 0-22.566407 18.292969-40.863281 40.863281-40.863281 22.566407 0 40.863281 18.296874 40.863281 40.863281zm0 0",
    fill: "url(#l)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m141.765625 244.867188v-55.089844c0-34.785156 15.949219-65.839844 40.929687-86.265625-19.617187 3.167969-39.542968 4.792969-59.59375 4.792969-48.269531 0-87.402343 39.132812-87.402343 87.402343v43.230469c0 48.269531 39.132812 87.402344 87.402343 87.402344 20.050782 0 39.976563 1.625 59.59375 4.792968-24.980468-20.421874-40.929687-51.480468-40.929687-86.265624zm0 0",
    fill: "url(#m)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m512 217.953125c0-120.371094-46.777344-217.953125-104.484375-217.953125-57.703125 0-104.484375 97.582031-104.484375 217.953125s46.78125 217.953125 104.484375 217.953125c57.707031 0 104.484375-97.582031 104.484375-217.953125zm0 0",
    fill: "url(#n)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m482.703125 217.953125c0-96.441406-30.449219-174.621094-68.007813-174.621094-37.5625 0-68.011718 78.179688-68.011718 174.621094s30.449218 174.621094 68.011718 174.621094c37.558594 0 68.007813-78.179688 68.007813-174.621094zm0 0",
    fill: "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m477.71875 283.585938c-.109375.785156-.238281 1.5625-.371094 2.335937-.453125 2.800781-.941406 5.550781-1.464844 8.269531-.203124 1.09375-.40625 2.179688-.632812 3.25-1.511719 7.640625-3.25 14.945313-5.183594 21.878906-.285156 1.050782-.582031 2.085938-.878906 3.109376-.023438.109374-.058594.203124-.085938.300781-.296874 1.011719-.605468 2.023437-.914062 3.027343-.335938 1.09375-.667969 2.191407-1.027344 3.261719-.273437.871094-.546875 1.71875-.832031 2.5625-.121094.371094-.238281.726563-.371094 1.097657-.308593.90625-.621093 1.800781-.929687 2.679687-.382813 1.097656-.773438 2.195313-1.191406 3.277344-.34375.941406-.703126 1.871093-1.058594 2.789062-.191406.488281-.382813.988281-.585938 1.476563-.191406.488281-.382812.964844-.585937 1.453125-.390625.964843-.785157 1.90625-1.191407 2.851562-.238281.558594-.476562 1.105469-.726562 1.667969-.261719.605469-.523438 1.203125-.796875 1.785156-.308594.691406-.621094 1.371094-.941406 2.039063-1.597657 3.394531-3.265625 6.613281-4.992188 9.628906-10.902343 19.085937-24.070312 30.242187-38.261719 30.242187-32.210937 0-59.199218-57.519531-66.21875-134.738281-.09375-1.046875-.191406-2.097656-.273437-3.15625-.167969-1.917969-.320313-3.859375-.453125-5.816406-.023438-.296875-.035156-.59375-.058594-.894531-.121094-1.878906-.238281-3.777344-.335937-5.683594-.070313-1.226562-.128907-2.453125-.1875-3.679688-.015625-.261718-.027344-.511718-.039063-.777343l-.175781-4.429688c0-.132812 0-.265625-.015625-.382812-.046875-1.464844-.082031-2.917969-.117188-4.386719-.011718-.261719-.011718-.511719-.023437-.761719v-.109375c-.023437-1.035156-.050781-2.070312-.058594-3.109375-.015625-.726562-.027343-1.453125-.027343-2.191406-.011719-1.503906-.023438-3.003906-.023438-4.503906 0-1.503907.011719-3.003907.023438-4.503907 0-.714843.011718-1.429687.027343-2.148437.023438-1.191406.046875-2.382813.070313-3.574219 0-.25.011718-.5.011718-.75.023438-.847656.046876-1.679687.070313-2.515625.023437-1.070312.058594-2.132812.109375-3.191406.035156-1.191406.082031-2.382813.140625-3.578125.011719-.152344.011719-.320312.023437-.476562.011719-.414063.039063-.832032.058594-1.238282.238282-5.015625.574219-9.972656.992188-14.847656.117187-1.453125.25-2.894531.378906-4.335938 1.679688-.214843 3.386719-.332031 5.125-.332031 11.976562 0 22.734375 5.144531 30.207031 13.34375zm0 0",
    fill: "url(#p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m175.820312 237.097656h-1.621093c-6.828125 0-12.363281-5.539062-12.363281-12.367187v-30.441407c0-6.828124 5.535156-12.363281 12.363281-12.363281h1.621093c6.832032 0 12.367188 5.535157 12.367188 12.363281v30.441407c0 6.828125-5.535156 12.367187-12.367188 12.367187zm0 0",
    fill: "url(#q)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m212.449219 237.097656h-1.621094c-6.828125 0-12.363281-5.539062-12.363281-12.367187v-30.441407c0-6.828124 5.535156-12.363281 12.363281-12.363281h1.621094c6.832031 0 12.367187 5.535157 12.367187 12.363281v30.441407c0 6.828125-5.535156 12.367187-12.367187 12.367187zm0 0",
    fill: "url(#r)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m141.765625 244.867188v-48.769532h-22.679687c-5.792969 0-10.492188 4.699219-10.492188 10.492188v5.839844c0 3.066406 1.324219 5.8125 3.417969 7.730468l29.882812 29.882813c-.078125-1.714844-.128906-3.4375-.128906-5.175781zm0 0",
    fill: "url(#s)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m141.765625 196.097656h-22.679687c-5.792969 0-10.492188 4.699219-10.492188 10.492188v5.839844c0 5.796874 4.699219 10.492187 10.492188 10.492187h22.679687zm0 0",
    fill: "url(#t)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m353.722656 176.460938c-1.738281 0-3.449218.121093-5.132812.332031-1.242188 13.199219-1.90625 26.980469-1.90625 41.160156 0 13.722656.621094 27.074219 1.785156 39.886719 1.722656.21875 3.472656.34375 5.253906.34375 22.566406 0 40.863282-18.292969 40.863282-40.859375 0-22.570313-18.296876-40.863281-40.863282-40.863281zm0 0",
    fill: "url(#u)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdvertising);
export default __webpack_public_path__ + "static/media/icon-advertising.c2fdbc9f2b4fffb660ce306c82510209.svg";
export { ForwardRef as ReactComponent };